import { MASK } from '../../../../constants/mask';

export const REQUISITES_FIELDS = {
  dcName: 'name',
  bin: 'bin',
  address: 'address',
  iban: 'iban',
  bankName: 'bankName',
  bic: 'bic',
};

export const REQUISITES_INPUTS = [
  {
    name: 'dcName',
    label: 'ÐÐ°Ð¸Ð¼ÐµÐ½Ð¾Ð²Ð°Ð½Ð¸Ðµ Ð´Ð¸Ð»ÐµÑÑÐºÐ¾Ð³Ð¾ ÑÐµÐ½ÑÑÐ°',
    placeholder: 'Ð¢ÐÐ Â«...Â»',
    rules: { required: true },
  },
  {
    name: 'bin',
    label: 'ÐÐÐ',
    placeholder: '000000000000',
    mask: MASK.IIN,
    rules: { required: true },
  },
  {
    name: 'address',
    label: 'Ð®ÑÐ¸Ð´Ð¸ÑÐµÑÐºÐ¸Ð¹ Ð°Ð´ÑÐµÑ',
    placeholder: 'Ð³. ÐÐ»Ð¼Ð°ÑÑ, ÑÐ». ...',
    rules: { required: true },
  },
  {
    name: 'iban',
    label: 'ÐÐ¾Ð¼ÐµÑ Ð±Ð°Ð½ÐºÐ¾Ð²ÑÐºÐ¾Ð³Ð¾ ÑÑÑÑÐ° (IBAN)',
    placeholder: 'KZ00000000000000000',
    mask: MASK.IBAN,
    rules: {
      required: true,
      validate: (value) => {
        const clean = (value || '').replace(/_/g, '');
        return clean.length === 20 || 'ÐÐ¾Ð¼ÐµÑ ÑÑÑÑÐ° Ð´Ð¾Ð»Ð¶ÐµÐ½ ÑÐ¾Ð´ÐµÑÐ¶Ð°ÑÑ 20 ÑÐ¸Ð¼Ð²Ð¾Ð»Ð¾Ð²';
      },
    },
  },
  {
    name: 'bankName',
    label: 'ÐÐ°Ð¸Ð¼ÐµÐ½Ð¾Ð²Ð°Ð½Ð¸Ðµ Ð±Ð°Ð½ÐºÐ°',
    placeholder: 'ÐÐ Â«ÐÐ°Ð½ÐºÂ»',
    rules: { required: true },
  },
  {
    name: 'bic',
    label: 'ÐÐÐ',
    placeholder: 'KCJBKZKX',
    maxLength: 8,
    transform: (value) => value?.toUpperCase(),
    rules: {
      required: true,
      validate: (value) => (value || '').replace(/_/g, '').length === 8 || 'ÐÐÐ Ð´Ð¾Ð»Ð¶ÐµÐ½ ÑÐ¾Ð´ÐµÑÐ¶Ð°ÑÑ 8 ÑÐ¸Ð¼Ð²Ð¾Ð»Ð¾Ð²',
    },
  },
];

export const SELLER_REQUISITES_INPUTS = [
  {
    name: 'recipient',
    label: 'ÐÐ¾Ð»ÑÑÐ°ÑÐµÐ»Ñ',
    placeholder: 'Ð¤ÐÐ, ÐºÐ°Ðº Ð² Ð±Ð°Ð½ÐºÐµ',
    rules: { required: true },
  },
  {
    name: 'iban',
    label: 'IBAN Ð¿ÑÐ¾Ð´Ð°Ð²ÑÐ°',
    placeholder: 'KZ000000000000000000',
    mask: MASK.IBAN,
    rules: {
      required: true,
      validate: (value) => {
        const clean = (value || '').replace(/[_ ]/g, '').toUpperCase();
        return /^KZ[0-9A-Z]{18}$/.test(clean) || 'ÐÐ°Ð·Ð°ÑÑÑÐ°Ð½ÑÐºÐ¸Ð¹ IBAN â KZ Ð¸ 18 ÑÐ¸Ð¼Ð²Ð¾Ð»Ð¾Ð²';
      },
    },
  },
  {
    name: 'bankName',
    label: 'ÐÐ°Ð½Ðº Ð¿ÑÐ¾Ð´Ð°Ð²ÑÐ°',
    placeholder: 'ÐÐ Â«ÐÐ°Ð½ÐºÂ»',
    rules: { required: true },
  },
  {
    name: 'bic',
    label: 'ÐÐÐ / BIC Ð¿ÑÐ¾Ð´Ð°Ð²ÑÐ°',
    placeholder: 'KCJBKZKX',
    maxLength: 11,
    transform: (value) => value?.toUpperCase(),
    rules: {
      required: true,
      validate: (value) => {
        const clean = (value || '').replace(/[_ ]/g, '').toUpperCase();
        return /^[A-Z]{8}([A-Z0-9]{3})?$/.test(clean) || 'ÐÐÐ â 8 Ð»Ð°ÑÐ¸Ð½ÑÐºÐ¸Ñ Ð¸Ð»Ð¸ SWIFT Ð½Ð° 11';
      },
    },
  },
];

export const sellerFio = (seller) => {
  const client = seller?.client || seller;
  if (!client) return seller?.label || '';
  return [client.surname, client.name, client.middlename].filter(Boolean).join(' ').trim();
};

export const withDefaults = (inputs, values) =>
  inputs.map((item) => ({ ...item, defaultValue: values?.[item.name] ?? '' }));

export const cleanBank = (value) => String(value || '').replace(/[_ ]/g, '').toUpperCase();
